import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access';

@Injectable({
  providedIn: 'root'
})
export class PolicyBreadcrumbResolver {
  constructor(private featureflagService: FeatureFlagService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<string> | Promise<string> | string {
    return of(this.resolveBreadcrumb(route.data['resolveKey'], route));
  }

  private resolveBreadcrumb(key, route: ActivatedRouteSnapshot): string {
    let breadcrumb = '';
    switch (key) {
      case 'auto':
        const isNewTemplate = this.featureflagService.isEnabled('policy_new_template');
        breadcrumb = isNewTemplate ? 'Auto' : route.paramMap.get('id') || '';
        break;

      case 'property':
        const newPropertyTemplate = this.featureflagService.isEnabled(
          'property_policy_new_template'
        );
        breadcrumb = newPropertyTemplate ? 'Home' : route.paramMap.get('id') || '';
        break;

      case 'life':
        const newLifeTemplate = this.featureflagService.isEnabled('life_policy_new_template');
        breadcrumb = newLifeTemplate ? 'Life' : route.paramMap.get('id') || '';
        break;

      case 'umbrella':
        const newUmbrellaTemplate = this.featureflagService.isEnabled(
          'umbrella_details_new_design'
        );
        breadcrumb = newUmbrellaTemplate ? 'Umbrella' : route.paramMap.get('id') || '';
        break;

      default:
        breadcrumb = route.paramMap.get('id') || '';
        break;
    }
    return breadcrumb;
  }
}
